import { LoadingButton } from "@mui/lab";
import { Box, Grid, MenuItem, Select, Typography } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import currencyCodes from "currency-codes";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../../../../components/CustomInput";
import { addBank } from "../../../../../constants/data";
import { addBankValidation } from "../../../../../helper/Validation";
import { useForm } from "../../../../../hooks/useForm";
import style from "./style";

function AddBankPage({ handleNewBank, loading }) {
  const navigate = useNavigate();
  const handleBankData = async (formState) => {
    const finalData = {
      accountName: formState.accountName.value,
      accountCode: formState.accountCode.value,
      accountNumber: formState.accountNumber.value,
      bankName: formState.bankName.value,
      ifsc: formState.ifsc.value,
      description: formState.description.value,
      currency: formState.currency?.value || "USD",
      isPrimary: isPrimary,
    };

    const success = await handleNewBank(finalData);
    if (success) {
      navigate("/dashboard/bankHome");
    }
  };

  const [isPrimary, setIsPrimary] = useState(false);
  const currencies = currencyCodes.data;

  const { state, handleChange, handleSubmit, handleFocus, disable } = useForm(
    addBank,
    addBankValidation,
    handleBankData
  );

  useEffect(() => {
    // Ensure intlTelInput library is loaded
    if (window.intlTelInputGlobals) {
      // Initialize the plugin on the input element
      window.intlTelInputGlobals.loadUtils("build/js/utils.js"); // Load utils file
    }
  }, []);

  const {
    accountName,
    accountCode,
    currency,
    accountNumber,
    bankName,
    ifsc,
    description,
  } = state;

  return (
    <Box px="15px" pt="20px">
      <form onSubmit={(e) => handleSubmit(e)}>
        <Typography sx={style.heading}>Add Bank Account</Typography>
        <Box>
          <Grid container>
            <Grid item xs={12} sx={style.card}>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>Account Name</Typography>
                  <CustomInput
                    name="accountName"
                    fullWidth
                    placeholder="Account Name"
                    value={accountName?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={accountName?.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>Account Code</Typography>
                  <CustomInput
                    name="accountCode"
                    fullWidth
                    value={accountCode?.value}
                    placeholder="Code"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={accountCode?.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>Currency</Typography>
                  <Select
                    value={currency?.value || "USD"}
                    onChange={(e) => handleChange("currency", e.target.value)}
                    name="Currency"
                    sx={style.countryInput}
                    fullWidth
                  >
                    {currencies.map((c) => (
                      <MenuItem
                        key={c.code}
                        value={c.code}
                        sx={style.dropDownMenu}
                      >
                        {c.code}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>Account Number</Typography>
                  <CustomInput
                    name="accountNumber"
                    fullWidth
                    // type={"number"}
                    value={accountNumber?.value}
                    placeholder="Account Number"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={accountNumber?.error}
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>Bank Name</Typography>
                  <CustomInput
                    name="bankName"
                    fullWidth
                    value={bankName?.value}
                    placeholder="Bank Name"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={bankName?.error}
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <Typography sx={style.inputText}>IFSC</Typography>
                  <CustomInput
                    name="ifsc"
                    fullWidth
                    value={ifsc?.value}
                    placeholder="IFSC Code"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={ifsc?.error}
                  />
                </Box>
              </Box>
              <Box sx={style.descriptionSection}>
                <Box sx={style.descriptionBox}>
                  <Typography sx={style.inputText}>Description</Typography>
                  <CustomInput
                    name="description"
                    value={description?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={description?.error}
                    multiline
                  />
                </Box>
              </Box>
              <Box sx={{ ...style.inputBox, ml: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isPrimary}
                      onChange={(e) => setIsPrimary(e.target.checked)}
                    />
                  }
                  label="Make this primary"
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "end" }}>
                <Box px={2}>
                  <LoadingButton
                    loading={loading}
                    variant="contained"
                    sx={style.jobButtons}
                    type="submit"
                    disabled={disable}
                  >
                    Save
                  </LoadingButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>
    </Box>
  );
}

export default AddBankPage;
